<script>
import {
  iButton,
  iButtonSizes,
  iButtonStyles,
  iButtonTypes,
  iTooltip,
  iTooltipAlignmentMode,
} from '@inscribe/signal';

export default {
  name: 'signal-button',
  components: {
    iButton,
    iTooltip,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    tooltipTitle: {
      type: String,
      required: true,
    },
    toggleRotated: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      iButtonSizes,
      iButtonStyles,
      iButtonTypes,
      iTooltipAlignmentMode,
    };
  },
  methods: {},
};
</script>

<template>
  <div class="document-view-tool-button i-radius-md">
    <i-button
      :id="id"
      :class="{ rotated: toggleRotated }"
      :left-icon="icon"
      :type="iButtonTypes.NEUTRAL"
      :button-style="iButtonStyles.GHOST"
      :size="iButtonSizes.SMALL"
      @button-click="$emit('button-click')"
    ></i-button>
    <i-tooltip
      :target="id"
      :title="tooltipTitle"
      :alignment="iTooltipAlignmentMode.LEFT_MIDDLE"
    />
  </div>
</template>

<style scoped lang="scss">
.document-view-tool-button {
  background: $light-neutral-default;
  border: 1px solid $light-neutral-60;
  padding: 2px;

  .i-button {
    box-shadow: none;
    border: 0;

    &.rotated {
      transform: rotate(180deg);
    }
  }
}
</style>
